import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostHelpDeskNewSac,
	PostHelpDeskNewSacModel,
	PostHelpDeskNewSacParams,
} from 'domain/usecases';

export class RemotePostHelpDeskNewSac implements PostHelpDeskNewSac {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostHelpDeskNewSacModel>,
	) {}

	async post(params: PostHelpDeskNewSacParams): Promise<PostHelpDeskNewSacModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
